// Crowded's web app, where an org logs in with the phone number on its
// Crowded account to manage it directly (cancel a pending payout, etc.).
export const CROWDED_APP_URL = "https://app.crowdedfinance.com/";

// Crowded's support site and address for account / bank application questions.
export const CROWDED_SUPPORT_URL = "https://support.crowdedfinance.com/";
export const CROWDED_SUPPORT_EMAIL = "support@crowded.me";
